import { createSelectField } from './createSelectField';
import { ReportingGroup } from 'types';

export const reportingGroupFieldProps = {
  getOptionLabel: ({ title }: ReportingGroup) => title,
  getOptionValue: (a: ReportingGroup) => a.id.toString(),
};

export const ReportingGroupField = createSelectField<ReportingGroup>('reporting/groups/', reportingGroupFieldProps);
